var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item",class:{clickable: _vm.clickable},on:{"click":_vm.onClick}},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"span-q"},[_vm._v(_vm._s(_vm.spanText))]),_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.showArr)?_c('img',{staticClass:"arr",attrs:{"src":"static/image/arrow_in@2x.png"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7689e25a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListItem.vue
// module id = a6Jg
// module chunks = 0